module.exports = "/fonts/RistrettoPro-Regular.ttf";